/**
 * Las tres barras y el muro. La marca sin el nombre.
 *
 * En la tablet del juez va la marca sola y no el lockup completo: la
 * barra superior tiene que dejar sitio al estado de sincronización y al
 * selector de heat, que es lo que se mira durante la competencia.
 */
export function LogoMark({ size = 26 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 128 128" role="img" aria-label="Time Cap">
      <rect x="14" y="27" width="58" height="17" rx="8.5" fill="#D2FF3A" />
      <rect x="14" y="55.5" width="85" height="17" rx="8.5" fill="#D2FF3A" />
      <rect x="14" y="84" width="44" height="17" rx="8.5" fill="#D2FF3A" />
      <rect x="99" y="12" width="17" height="104" rx="8.5" fill="#FF3B30" />
    </svg>
  );
}
